import React, { useState, useRef } from "react";
import {
  Col,
  DatePicker,
  Row,
  Spin,
  Form,
  Input,
  InputNumber,
  TimePicker,
  Select,
  Table,
  Tag,
} from "antd";
import "./ManualEntry.css";
import ButtonComp from "../../ButtonComp/ButtonComp";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from "../../../Utils/imports";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

const { Option } = Select;

const ManualEntry = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);
  const [form] = Form.useForm();
  const { current = null } = useSelector((state) => state.plant);
  const { line } = useSelector((state) => state?.plant?.current);
  const { products } = useSelector((state) => state.productionLine);
  let { machine = null } = current;
  const [displayWarning, setDisplayWarning] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  // const [products, setProduct] = useState({
  //   // timestamp:
  // });
  const [selectedShift, setSelectedShift] = useState();
  // `${current?.shift?.name} ${current?.shift?.range}`
  const [addMoreProducts, setAddMoreProducts] = useState([true]);
  const [addDowntimeDetails, setAddDowntimeDetails] = useState([]);

  const onShiftChange = (shift) => {
    const selectedShift = JSON.parse(shift);
    setSelectedShift(selectedShift);
  };
  const handleToggleContent = (index) => {
    setAddMoreProducts((prevState) => prevState.filter((_, i) => i !== index));
  };

  const handleToggleDowntime = (index) => {
    setAddDowntimeDetails((prevState) =>
      prevState.filter((_, i) => i !== index)
    );
  };

  const handleAddMoreContent = () => {
    setAddMoreProducts([...addMoreProducts, {}]);
  };

  const handleAddDowntimeDetails = () => {
    setAddDowntimeDetails([...addDowntimeDetails, {}]);
  };

  const handleFormSubmit = async(value) => {
    // e.preventDefault();
    console.log(value)
    setShowMoreContent(!showMoreContent);
  };

  const handleFormSubmit1 = (values) => {
    const formValues = form.getFieldsValue();
    console.log("Form Values before logging:", values);
    console.log("Form Values:", JSON.stringify(formValues, null, 2));
  };
  

  const handleCancel = () => {
    setShowMoreContent(false);
  };
  const convertTimeString = ({ string, day }) => {
    const [hours, minutes] = string.split(":");
    const date = moment(day).set({
      hours,
      minutes,
      seconds: 0,
      milliseconds: 0,
    });
    return date.toDate();
  };
  const handleDateChange = (date) => {
    setSelectedDate(date || moment(current?.shiftDate) || moment(new Date()));
  };

  const validateChangeoverTime = (shift, timeNow) => {
    if (timeNow == null) {
      return Promise.reject("Changeover Time is required");
    }

    let fromTime = convertTimeString({ string: shift.from, day: timeNow });
    let toTime = convertTimeString({ string: shift.to, day: timeNow });

    // if ending time is after midnight
    if (moment(toTime).isBefore(fromTime)) {
      // if current time is after midnight
      if (moment(fromTime).isAfter(moment(timeNow))) {
        fromTime = moment(fromTime).subtract(1, "day").toDate();
      } else {
        toTime = moment(toTime).add(1, "day").toDate();
      }
    }

    if (
      moment(fromTime).isSameOrBefore(timeNow) &&
      moment(toTime).isSameOrAfter(timeNow)
    ) {
      return Promise.resolve();
    } else {
      return Promise.reject("Should be in shift range");
    }
  };

  const validateTime = async (rule, value) => {
    try {
      const timeNow = value;
      const shift = JSON.parse(current.shift);
      await validateChangeoverTime(shift, timeNow);
    } catch (error) {
      throw new Error(error);
    }
  };

  const validatePositiveNumber = (_, value) => {
    if (value <= 0) {
      return Promise.reject("Must be a positive number");
    }
    return Promise.resolve();
  };

  const handleProductionChange = (key, ev) => {
    const values = form.getFieldsValue();
    let prevTime = null;
    Object.keys(values).forEach((k, index) => {
      const obj = values[k];
      obj.time = moment(
        index === 0 ? current.activeShift.fromTime : prevTime
      ).add(
        (obj.planned ? obj.planned : 0) +
          (k === key ? ev : obj.production ? obj.production : 0),
        "minutes"
      );
      prevTime = obj.time;
    });
    form.setFieldsValue(values);
    showWarning();
  };

  const handlePlannedDowntimeChange = (key, ev) => {
    const values = form.getFieldsValue();
    let prevTime = null;
    Object.keys(values).forEach((k, index) => {
      const obj = values[k];
      obj.time = moment(
        index === 0 ? current.activeShift.fromTime : prevTime
      ).add(
        (obj.production ? obj.production : 0) +
          (k === key ? ev : obj.planned ? obj.planned : 0),
        "minutes"
      );
      prevTime = obj.time;
    });
    form.setFieldsValue(values);
    showWarning();
  };

  const showWarning = () => {
    setDisplayWarning(true);
  };

  const validateDowntime = (_, value) => {
    const values = form.getFieldsValue();
    // if (value == null || value < 0) {
    //   return Promise.reject("Must be a positive number");
    // } else if (value > values[products.timestamp].production) {
    //   return Promise.reject("Must be less than production");
    // } else {
    //   return Promise.resolve();
    // }
  };

  const historyTable = [
    { id: "reportId", name: "xyz" },
    { id: "product", name: "saaad" },
    { id: "downtime", name: "abc" },
    { id: "plannedDowntime", name: "aaa" },
    { id: "lineId", name: "cba" },
  ];

  const HistryColumns = [
    {
      // title: 'ID',
      dataIndex: "id",
      key: "id",
    },
    {
      // title: 'Name',
      dataIndex: "name",
      key: "name",
    },
  ];

  return (
    <>
      <div>
        {!showMoreContent ? (
          <>
            <Row className="pt1">
              <Col span={12}>
                <h1 className="pageHead">Manual Entry</h1>
              </Col>
            </Row>
            <Row className="width100P pt10">
              <Col span={24}>
                <span>Please Select Date and Shift</span>
              </Col>
            </Row>
            <Form
              style={{ width: "100%" }}
              layout="vertical"
              onFinish={handleFormSubmit}
            >
              <Row gutter={24} className="pt20">
                <Col span={6}>
                  <Form.Item name = 'date'>
                    <DatePicker
                      value={selectedDate ? moment(selectedDate) : ""}
                      className="boxBorderRad"
                      placeholder="Select Date"
                      allowClear={false}
                      style={{ width: "100%" }}
                      onChange={handleDateChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name = 'shift'>
                    <Select
                      onChange={onShiftChange}
                      placeholder="Select Shift"
                      value={
                        selectedShift &&
                        `${selectedShift.name} ${selectedShift.range}`
                      }
                    >
                      {(machine && machine.shifts) ||
                      (current && current.shifts)
                        ? (
                            (machine && machine.shifts) ||
                            (current && current.shifts)
                          ).map((shift, index) => (
                            <Option
                              key={JSON.stringify(shift)}
                              value={JSON.stringify(shift)}
                            >
                              {shift.name} {shift.range}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24} className="pt10">
                <Col
                  span={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <ButtonComp
                      theme="blue"
                      // onClick={handleFormSubmit}
                      text="Ok"
                      icon={<CheckCircleFilled />}
                    />
                </Col>
              </Row>
            </Form>
          </>
        ) : (
          <div>
            <Row gutter={24} className="pt1">
              <Col span={6} className="dflex">
                <h1 className="pageHead">Manual Entry</h1>
              </Col>
              <Col span={6} style={{ paddingTop: "3px" }}>
                <div className="dflex">
                  <Tag className="formTag">
                    {moment(selectedDate).format("DD MMMM YYYY")}
                  </Tag>
                  <Tag className="formTag">
                    {selectedShift &&
                      `${selectedShift.name} ${selectedShift.range}`}
                  </Tag>
                </div>
              </Col>
            </Row>
            <Row gutter={24} className="width100P pt20">
              <Col span={6}>
                <span>Add Production Details</span>
              </Col>
              <Col
                span={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: "0px !important",
                }}
              >
                <PlusCircleOutlined
                  className="plusIcon"
                  onClick={handleAddMoreContent}
                />
              </Col>
            </Row>
            <Form
              form={form}
              name="manualEntry"
              initialValues={{
                remember: false,
            }}
              style={{ width: "100%" }}
              layout="vertical"
              onFinish={handleFormSubmit1}
            >
              {addMoreProducts.map((product, index) => (
                <React.Fragment key={index}>
                  <Row gutter={24} className="pt20">
                    <Col span={index !== 0 ? 10 : 12}>
                      <Form.Item
                      name={`productName_${index}`}>
                        <Select
                          style={{ width: "100%" }}
                          tokenSeparators={[","]}
                        >
                          {products.map((machine) => (
                            <Select.Option
                              key={machine.productName}
                              value={machine._id}
                            >
                              {machine.productName}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    {index !== 0 && (
                      <Col
                        span={2}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <MinusCircleOutlined
                          className="minusIcon"
                          onClick={() => handleToggleContent(index)}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row gutter={24} className="pt10">
                    <Col span={4}>
                      <Form.Item
                      name={`ChangeOver_${index}`}
                        // rules={[{ validator: validateChangeoverTime }]}
                      >
                        <TimePicker
                          disabled
                          use12Hours
                          format="h:mm:ss a"
                          placeholder="Changeover Time"
                          className="boxBorderRad width100P"
                        />
                      </Form.Item>
                      {/* <Form.Item>
                    <InputNumber
                      style={{ background: "#DADCE1" }}
                      className="boxBorderRad width100P"
                      placeholder={"Change Overtime"}
                      type="number"
                      disabled
                    />
                  </Form.Item> */}
                    </Col>
                    <Col span={4}>
                      <Form.Item
                      name={`goodCount_${index}`}>
                        <InputNumber
                          className="boxBorderRad width100P"
                          placeholder={"Good Count"}
                          type="number"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                      name={`rejection_${index}`}>
                        <InputNumber
                          className="boxBorderRad width100P"
                          placeholder={"Rejection"}
                          type="number"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24} className="pt10">
                    <Col span={4}>
                      <Form.Item
                      name={`productionTime_${index}`}
                        validateStatus={displayWarning ? "warning" : "success"}
                        help={
                          displayWarning
                            ? "Remaining Time will be considered as downtime"
                            : ""
                        }
                        rules={[
                          {
                            type: "number",
                            min: 0,
                            required: true,
                            validator: validatePositiveNumber,
                          },
                        ]}
                      >
                        <InputNumber
                          onChange={handleProductionChange}
                          className="boxBorderRad width100P"
                          placeholder="Production Time(min)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                      name={`downtime_${index}`}
                        rules={[
                          {
                            type: "number",
                            min: 0,
                            required: true,
                            validator: validateDowntime,
                          },
                        ]}
                      >
                        <InputNumber
                          className="boxBorderRad width100P"
                          placeholder="Downtime(min)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                      name={`plannedDowntime_${index}`}
                        rules={[
                          {
                            type: "number",
                            min: 0,
                          },
                        ]}
                      >
                        <InputNumber
                          onChange={handlePlannedDowntimeChange}
                          className="boxBorderRad width100P"
                          placeholder="Planned Downtime(min)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </React.Fragment>
              ))}
              {/* {line?.isGSK &&  */}
              <div>
                <Row gutter={24} className="width100P pt20">
                  <Col span={6}>
                    <span>Add Downtime Details</span>
                  </Col>
                  <Col
                    span={6}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      paddingRight: "0px !important",
                    }}
                  >
                    <PlusCircleOutlined
                      className="plusIcon"
                      onClick={handleAddDowntimeDetails}
                    />
                  </Col>
                </Row>
                {addDowntimeDetails.map((product, index) => (
                  <React.Fragment key={index}>
                    <Row gutter={24} className="pt20">
                      <Col span={5}>
                        <Form.Item name={`start-${index}`}>
                          <TimePicker
                            use12Hours
                            format="h:mm a"
                            placeholder="Start Time"
                            className="boxBorderRad width100P"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item name={`end-${index}`}>
                          <TimePicker
                            use12Hours
                            format="h:mm a"
                            placeholder="End Time"
                            className="boxBorderRad width100P"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        span={2}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <MinusCircleOutlined
                          className="minusIcon"
                          onClick={() => handleToggleDowntime(index)}
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                ))}
              </div>
              {/* } */}
              <Row gutter={24} className="pt10">
                <Col
                  span={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <ButtonComp
                      style={{ width: "150px", marginRight: '30px' }}
                      theme="red"
                      text="Cancel"
                      icon={<CloseCircleFilled />}
                      onClick={handleCancel}
                    />
                    <ButtonComp
                      style={{ width: "150px" }}
                      theme="blue"
                      htmlType="submit"
                      text="Save"
                      icon={<CheckCircleFilled />}
                    />
                </Col>
              </Row>
            </Form>
            {/* {line?.isTreet && */}
            <div>
              <Row gutter={24} className="width100P pt20">
                <Col span={6}>
                  <span>History</span>
                </Col>
              </Row>
              <Row gutter={24} className="pt20">
                <Col span={12}>
                  <Table
                    columns={HistryColumns}
                    dataSource={historyTable}
                    pagination={false}
                    showHeader={false}
                  />
                </Col>
              </Row>
            </div>
            {/* } */}
          </div>
        )}
      </div>
    </>
  );
};
export default ManualEntry;
